import { includes, reduce, set } from 'lodash/fp';

import { FIELD_NAMES, INCOME_TIER_NONE, SCALES_WITH_MULTIPLE_ADULTS } from '../../constants';
import { FieldNames } from '../../types';
import uncapFpIterator from '../../../../../utils/uncap-fp-iterator';

const { INCOME_TIER, PARTNER_AGE } = FIELD_NAMES;

const reduceWithIndex = uncapFpIterator(reduce);
const INITIAL_VALUE = {};

type Params = {
  initialValues: {
    [key in FieldNames]?: any;
  };
  formValues: {
    [key in FieldNames]?: any;
  };
  scale: string;
};

const getUpdatedFields = ({ initialValues, formValues, scale }: Params) => {
  const exceptionList = [INCOME_TIER, PARTNER_AGE];
  const scaleForPartnerAge = formValues?.scale || scale;
  const updatedFormValues = reduceWithIndex((accumulator: object, formValue: string, key: string) => {
    // @ts-expect-error - Automatic, Please fix when editing this file
    const hasValueChanged = formValue !== initialValues[key];

    if (hasValueChanged && !includes(key, exceptionList)) {
      return set(key, formValue, accumulator);
    }
    if (key === INCOME_TIER && formValue !== INCOME_TIER_NONE && hasValueChanged) {
      return set(key, formValue, accumulator);
    }
    if (key === INCOME_TIER && formValue === INCOME_TIER_NONE && initialValues.rebate === true) {
      return set(key, formValue, accumulator);
    }
    if (key === PARTNER_AGE && includes(scaleForPartnerAge, SCALES_WITH_MULTIPLE_ADULTS) && hasValueChanged) {
      return set(key, formValue, accumulator);
    }
    return accumulator;
  }, INITIAL_VALUE)(formValues);
  return updatedFormValues;
};

export default getUpdatedFields;
